module.exports = __webpack_public_path__ + "static/video-039ae85e0b481d62b6e7bf04ce52664d.mp4";